import { Component } from '@angular/core';
import { PagesService } from '@app/_services/pages.service';
import {LicenceService} from "@app/_services/licence.service";
import { PublicationsService } from '@app/_services/publications.service';
import SwiperCore, {Navigation, SwiperOptions} from 'swiper';
import {filter} from "rxjs/operators";
import { AuthenticationService } from '@app/_services';

@Component({
  selector: 'jumbotron',
  templateUrl: './jumbotron.component.html',
  styleUrls: ['./jumbotron.component.scss']
})
export class JumbotronComponent {

  public news=[];
  public archive: any[] =[];

    public config: SwiperOptions = {
      slidesPerView: "auto",
      spaceBetween: 24,
      centeredSlides: true,
      pagination: {
        clickable: true,
      },
      modules: [Navigation],
      autoplay:{
        delay: 5000
      }
    };

  constructor(
    public authService: AuthenticationService,
    private pagesService: PagesService,
     private publicationsService: PublicationsService,
  ){}

  get currentPage(){

    return this.pagesService.currentPage
  }

  get name(){
    return this.currentPage?.h1 || this.currentPage?.name
  }

  get isRootPage(){
    return this.pagesService.currentPage && this.pagesService.currentPage.parents && this.pagesService.currentPage.parents.data.length === 0
  }

  get bgStyle(){
    let height = 50;
    let pictURL:string;
    if (this.currentPage){
      height = 150;
      pictURL = this.currentPage?.picture?.data.links.open;
    }

    return {
      'background-image' : `url(${pictURL})`||'none',
      'height': (pictURL?400:height) + 'px'
    }
  }

  get h1Style(){
    return { color: this.currentPage?.picture?'var(--white)':'var(--second-act)'}
  }

  get editable() {
    return this.currentPage?.permissions?.edit || this.currentPage?.permissions?.anything;
  }

  get editMode() {
    return this.pagesService.editMode;
  }

  get isLoggedIn() {
    return this.authService.isLoggedIn;
  }

  ngOnInit(){
    this.pagesService.list({filters:JSON.stringify({slug: 'anonsy'}),include: 'publications.posters'}).subscribe(resp=>{
      this.news = resp.data[0].publications.data.slice(0,5)      
      .map(news=>({
        title:news.name,
        sub:news.excerpt,
        img: news.posters?.data[0]?.links.download,
        link: news.link,         
      }))
    });
    this.pagesService.list({filters:JSON.stringify({slug: 'novosti'}),include: 'publications.posters'}).subscribe(resp=>{
      this.archive = resp.data[0].publications.data.slice(0,3)
      .map(news=>({
        title:news.name,
        sub:news.excerpt,
        img: news.posters?.data[0]?.links.download,
        link: news.link,
        tag: news.tag         
      }))
    })
  }

  toggleEditMode() {
    this.pagesService.editMode = !this.pagesService.editMode;
  }

  trimText(text, length, end = '') {
  let index = text.indexOf(" ", length);
  if( index == -1 ) index = length;

  return text.slice(0, index) + end;
}

}
